<template>
  <div class="telehealth">
    <div class="content" ref="homeContent">
      <section class="d-flex flex-grow-1" v-if="loaded">
        <b-container fluid class="d-flex flex-column">
          <b-row class="flex-grow-1">
            <b-col class="info" lg="10" offset-lg="1" xl="8" offset-xl="2">
              <b-row class="page-header m-md-0 pt-2 pt-lg-3 text-center text-lg-left">
                <b-col lg="auto" class="d-none d-lg-block">
                  <img :src="logo" height="80" class="mb-3" :alt="name">
                </b-col>
                <b-col cols="12" lg="6" class="d-flex flex-column justify-content-center mb-3">
                  <h1 class="mb-0">{{ name }}</h1>
                  <h4 class="font-lighter mb-0">{{telehealthAppointment.appointment_type}} com {{telehealthAppointment.professional}}</h4>
                </b-col>
                <b-col class="d-none d-lg-flex flex-column justify-content-center mb-3 text-lg-right">
                  <p class="mb-1">Paciente: {{telehealthAppointment.patient.name}}<i class="far fa-user ml-2"></i></p>
                  <p class="mb-0">Início: {{moment(telehealthAppointment.start_datetime).format('HH:mm')}}<i class="far fa-clock ml-2"></i></p>
                </b-col>
              </b-row>

              <b-row class="mt-2">
                <b-col cols="12">
                  <div class="box-cj mb-3">
                    <div id="attendance_content" class="content p-0 d-flex justify-content-center align-items-center">
                      <div v-if="telehealthAttendance != null && telehealthAttendance.start_datetime == null" class="text-center">
                        <div class="professional-status-text"><i class="far fa-clock text-primary mr-2"></i>Aguardando {{telehealthAppointment.professional}}.</div>
                        <i class="far fa-spinner fa-spin professional-status-loading"></i>
                      </div>
                      <div v-else-if="telehealthAttendance != null && telehealthAttendance.start_datetime != null && telehealthAttendance.end_datetime == null" class="agora-uikit-cj">
                        <div class="agora-call">
                          <div id="participants"></div>
                          <div style="background-color: rgb(0, 123, 255); width: 100%; height: 70px; z-index: 10; display: flex; flex-direction: row; justify-content: space-evenly; align-items: center;">
                            <b-button @click="toggleCamera()" variant="primary" pill lg style="width: 38px;font-size:18px" class="px-0 text-center"><i :class="'far fa-video' + (videoEnabled ? '' : '-slash')"></i></b-button>
                            <b-button @click="toggleMicrophone()" variant="primary" pill lg style="width: 38px;font-size:18px" class="px-0 text-center"><i :class="'far fa-microphone' + (audioMuted ? '-slash' : '')"></i></b-button>
                            <b-button @click="endTelehealthAttendance()" variant="danger" pill lg style="width: 38px;font-size:18px" class="px-0 text-center"><i class="far fa-phone-slash"></i></b-button>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="telehealthAttendance != null && telehealthAttendance.end_datetime != null" class="text-center">
                        <div>Teleconsulta finalizada.</div>
                      </div>
                    </div>
                  </div>
                </b-col>
                <b-col cols="12">
                  <p class="credits text-center mb-3">Ambiente seguro&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Powered by <a href="https://consultaja.com" target="_blank">Consultaja.com</a></p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </div>
  </div>
</template>
<script>
import AgoraRTC from "agora-rtc-sdk-ng";
export default {
  data() {
    return {
      isLoading: null,

      agoraId: process.env.VUE_APP_AGORA_ID,
      agoraToken: '',
      agoraClient: null,
      localAudioTrack: null,
      audioMuted: false,
      localVideoTrack: null,
      loadedChannel: false,
      leftChannel: false,
      videoEnabled: true,
      spectators: [],

      code: null,

      audioAlert: new Audio('/audio/professional_entered.mp3'),

      telehealthCheckInterval: null,

      loaded: false,

      enableTelehealth: true,

      telehealthAttendance: null,
      telehealthAppointment: null,

      logo: require('@/assets/images/avatar.svg'),
      name: null,

      canPerformAction: true
    }
  },
  mounted() {
    this.eventBus.$on('IS_LOADING', (isLoading) => {
      if(isLoading) {
        this.isLoading = this.$loading.show({
          container: this.$refs.homeContent,
          canCancel: false,
          isFullPage: false,
          color: '#21A7F0',
          backgroundColor: '#212C3B'
        });
      } else {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null)
          this.isLoading.hide();
      }
    });

    this.loadTelehealthAppointment();
  },
  methods: {
    async loadTelehealthAppointment() {
      this.code = localStorage.getItem('telehealth-code-' + this.$route.params.id);
      if(this.code === null) {
        let {value: inputCode} = await this.$swal({
          title: 'Controle de acesso',
          text: 'Por favor, insira o código de acesso de 5 dígitos que você recebeu.',
          input: 'tel',
          inputLabel: 'Código de acesso',
          inputAttributes: {
            maxlength: 5,
            autocapitalize: 'off',
            autocorrect: 'off'
          },
          showCancelButton: false,
          // cancelButtonText: 'Cancelar',
          inputValidator: (value) => {
            if (value.length === 0) {
              return 'Você tem que preencher o código de acesso!'
            }
            if (value.length !== 5) {
              return 'O código de acesso possui 5 dígitos!'
            }
          }
        });
        if (inputCode) {
          this.code = inputCode;
        }
      }
      if (this.code) {
        this.eventBus.$emit('IS_LOADING', true);
        this.canPerformAction = false;
        this.getTelehealthAppointment();
      }
    },
    getTelehealthAppointment() {
      this.api.getTelehealthAppointment(this.$route.params.id, {code: this.code}).then(res => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;
        this.loaded = true;

        localStorage.setItem('telehealth-code-' + this.$route.params.id, this.code);

        let appointmentData = res.data;
        if(appointmentData.professional_photo) {
          this.logo = appointmentData.professional_photo;
        }
        else if(appointmentData.agenda_logo) {
          this.logo = appointmentData.agenda_logo;
        }
        else if(appointmentData.logo) {
          this.logo = appointmentData.logo;
        }
        this.name = appointmentData.name;

        this.agoraToken = appointmentData.agora_token;
        this.telehealthAppointment = appointmentData.telehealth_appointment;
        this.telehealthAttendance = appointmentData.telehealth_attendance;
        this.spectators = appointmentData.spectators;

        if(this.telehealthAttendance.start_datetime == null || this.telehealthAttendance.end_datetime == null) {
          this.telehealthCheckInterval = setInterval(this.checkTelehealthAttendance, 15*1000);
          if(this.telehealthAttendance.start_datetime != null) {
            this.initializeClient();
            this.joinChannel();
          }
        }

        if(process.env.VUE_APP_SHOW_CONSOLE)
          console.log('Success Get Telehealth Appointment', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;

        if(err.response.status == 403) {
          this.$swal('Ops...', 'Código de acesso inválido!', 'error').then(() => {
            this.loadTelehealthAppointment();
          });
        }
        else {
          let msg = 'Não conseguimos carregar este atendimento de teleconsulta! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
          switch (err.response.status) {
            case 400:
              msg = err.response.data.message;
              break;
          }
          this.$swal('Ops...', msg, 'error');
        }

        if(process.env.VUE_APP_SHOW_CONSOLE)
          console.log('Error Get Telehealth Appointment', err.response);
      });
    },

    async checkTelehealthAttendance() {
      await this.api.checkTelehealthAttendance(this.telehealthAttendance.id, {code: this.code}).then(res => {
        let justStarted = false;
        if(this.telehealthAttendance.start_datetime == null && res.data.start_datetime != null && res.data.end_datetime == null) {
          this.audioAlert.play();
          justStarted = true;
        }
        this.telehealthAttendance = res.data;
        if(this.telehealthAttendance.end_datetime != null) {
          clearInterval(this.telehealthCheckInterval)
          this.telehealthCheckInterval = null;
        }
        if(justStarted && this.agoraClient == null) {
          this.initializeClient();
          this.joinChannel();
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Check Telehealth Attendance', res);
      }).catch(err => {
        let msg = 'Não conseguimos carregar este atendimento de teleconsulta! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
        switch (err.response.status) {
          case 400:
            msg = err.response.data.message;
            break;
        }
        if(msg === 'Este atendimento já foi encerrado!') {
          if(this.telehealthAttendance.end_datetime == null) {
            this.telehealthAttendance.end_datetime = 1;
          }
          else {
            msg = null;
          }
        }
        if(msg) {
          this.$swal('Ops...', msg, 'error');
        }

        clearInterval(this.telehealthCheckInterval)
        this.telehealthCheckInterval = null;

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Check Telehealth Attendance', err.response);
      });
    },
    initializeClient() {
      this.agoraClient = AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' });
      this.setupAgoraEventListeners();
    },
    setupAgoraEventListeners() {
      this.agoraClient.on('user-published', async (user, mediaType) => {
        if(!this.leftChannel) {
          await this.agoraClient.subscribe(user, mediaType);
          this.loadParticipants();
        }
      });

      this.agoraClient.on('user-unpublished', async (user) => {
        if(!this.leftChannel) {
          let remotePlayerContainer = document.getElementById(user.uid);
          if(remotePlayerContainer) {
            let audioIndicator = remotePlayerContainer.querySelectorAll('.participant-audio.participant-' + user.uid)[0],
                noAudioIndicator = remotePlayerContainer.querySelectorAll('.participant-no-audio.participant-' + user.uid)[0];
            audioIndicator.style.display = user.hasVideo || !user.hasAudio ? 'none' : 'block';
            noAudioIndicator.style.display = user.hasAudio ? 'none' : 'block';
          }
        }
      });

      this.agoraClient.on('user-left', async (user) => {
        if(!this.leftChannel) {
          let remotePlayerContainer = document.getElementById(user.uid);
          if (remotePlayerContainer) {
            remotePlayerContainer && remotePlayerContainer.remove();
          }
          setTimeout(() => {
            document.getElementById('participants').style.gridTemplateColumns = this.getAgoraGridStyle(this.agoraClient.remoteUsers.length + 1);
          }, 500);
        }
      });
    },

    async joinChannel() {
      await this.agoraClient.join(this.agoraId, this.telehealthAttendance.id, this.agoraToken, this.telehealthAppointment.patient.id);
      await this.createLocalMediaTracks();
      await this.publishLocalTracks();
      this.loadParticipants();
      this.loadedChannel = true;
    },
    async createLocalMediaTracks() {
      this.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack();
      this.localVideoTrack = await AgoraRTC.createCameraVideoTrack();
    },
    async publishLocalTracks() {
      await this.agoraClient.publish([this.localAudioTrack, this.localVideoTrack]);
    },
    loadParticipants() {
      if(!this.localVideoTrack) {
        return;
      }
      let container = document.getElementById('participants');
      container.style.gridTemplateColumns = this.getAgoraGridStyle(this.agoraClient.remoteUsers.length + 1);
      if(!document.getElementById(this.telehealthAppointment.patient.id)) {
        this.displayLocalVideo(container);
      }

      let professionalUser = this.agoraClient.remoteUsers.find(user => user.uid === this.telehealthAppointment.professional_id);
      if(professionalUser) {
        this.displayRemoteVideo(container, this.telehealthAppointment.professional, professionalUser, -5);
      }

      this.agoraClient.remoteUsers.forEach((user) => {
        if(user.uid !== this.telehealthAppointment.professional_id) {
          let spectator = this.spectators.find(spectator => spectator.id === user.uid);
          this.displayRemoteVideo(container, spectator.name, user, null);
        }
      });
    },
    displayLocalVideo(container) {
      container.insertAdjacentHTML('beforeend', '' +
          '<div id="' + this.telehealthAppointment.patient.id + '" style="display: flex; flex: 1 1 0; height: 100%; width: 100%; order: -10">' +
            '<div style="display: flex; flex: 1 1 0; position: relative">' +
              '<p style="position: absolute; background: rgba(0, 123, 255, 0.667); padding: 2px 8px; color: rgb(255, 255, 255); margin: 0px; bottom: 0px; right: 0px; z-index: 90;">Paciente ' + this.telehealthAppointment.patient.name+ '</p>' +
              '<div class="participant-video participant-' + this.telehealthAppointment.patient.id + '" style="flex: 1 1 0%; display: flex; background-color: rgba(0, 123, 255, 0.2); flex-direction: row; position: relative;"></div>' +
              '<i class="fas fa-microphone text-white participant-audio participant-' + this.telehealthAppointment.patient.id + '" style="position: absolute;top: 50%;width: 100%;text-align: center;font-size: 40px;display:none"></i>' +
              '<div class="text-white participant-no-audio participant-' + this.telehealthAppointment.patient.id + '" style="position: absolute;top: 50%;width: 100%;text-align: center;font-size: 40px;display:none">' +
                '<div style="display:inline;border-radius:100%;background: rgba(0,0,0,0.2)"><i class="fas fa-microphone-slash" style="opacity:.85"></i></div>' +
              '</div>' +
            '</div>' +
          '</div>');
      this.localVideoTrack.play(document.querySelectorAll('.participant-video.participant-' + this.telehealthAppointment.patient.id)[0]);
    },
    displayRemoteVideo(container, name, user, order) {
      if(!document.getElementById(user.uid)) {
        container.insertAdjacentHTML('beforeend', '' +
            '<div id="' + user.uid + '" style="display: flex; flex: 1 1 0; height: 100%; width: 100%; ' + (order !== null ? ('order: ' + order) : '') + '">' +
              '<div style="display: flex; flex: 1 1 0; position: relative">' +
                '<p style="position: absolute; background: rgba(0, 123, 255, 0.667); padding: 2px 8px; color: rgb(255, 255, 255); margin: 0px; bottom: 0px; right: 0px; z-index: 90;">' + name + '</p>' +
                '<div class="participant-video participant-' + user.uid + '" style="flex: 1 1 0%; display: flex; background-color: rgba(0, 123, 255, 0.2); flex-direction: row; position: relative;"></div>' +
                '<i class="fas fa-microphone participant-audio participant-' + user.uid + '" style="position: absolute;top: 50%;width: 100%;text-align: center;font-size: 40px;display:none"></i>' +
                '<div class="text-white participant-no-audio participant-' + user.uid + '" style="position: absolute;top: 50%;width: 100%;text-align: center;font-size: 40px;display:none">' +
                  '<div style="display:inline;border-radius:100%;background: rgba(0,0,0,0.2)"><i class="fas fa-microphone-slash" style="opacity:.85"></i></div>' +
                '</div>' +
              '</div>' +
            '</div>');
      }
      if(user.hasVideo && user.videoTrack && !user.videoTrack.isPlaying) {
        user.videoTrack.play(document.querySelectorAll('.participant-video.participant-' + user.uid)[0]);
      }
      if(user.hasAudio && user.audioTrack && !user.audioTrack.isPlaying) {
        user.audioTrack.play();
      }
      let audioIndicator = document.querySelectorAll('.participant-audio.participant-' + user.uid)[0],
          noAudioIndicator = document.querySelectorAll('.participant-no-audio.participant-' + user.uid)[0];
      audioIndicator.style.display = user.hasVideo || !user.hasAudio ? 'none' : 'block';
      noAudioIndicator.style.display = user.hasAudio ? 'none' : 'block';
    },
    getAgoraGridStyle(amount) {
      let gridCellStyle = 'minmax(0px, 1fr)',
          gridStyle = [gridCellStyle];
      if(amount > 1) {
        gridStyle.push(gridCellStyle);
        if(amount > 4) {
          gridStyle.push(gridCellStyle);
        }
      }
      return gridStyle.join(' ');
    },
    toggleCamera() {
      this.videoEnabled = !this.videoEnabled;
      this.localVideoTrack.setEnabled(this.videoEnabled);
      document.querySelectorAll('.participant-audio.participant-' + this.telehealthAppointment.patient.id)[0].style.display = this.videoEnabled || this.audioMuted ? 'none' : 'block';
      document.querySelectorAll('.participant-no-audio.participant-' + this.telehealthAppointment.patient.id)[0].style.display = !this.audioMuted ? 'none' : 'block';
    },
    toggleMicrophone() {
      this.audioMuted = !this.audioMuted;
      this.localAudioTrack.setMuted(this.audioMuted);
      document.querySelectorAll('.participant-audio.participant-' + this.telehealthAppointment.patient.id)[0].style.display = this.videoEnabled || this.audioMuted ? 'none' : 'block';
      document.querySelectorAll('.participant-no-audio.participant-' + this.telehealthAppointment.patient.id)[0].style.display = !this.audioMuted ? 'none' : 'block';
    },
    async leaveChannel() {
      this.leftChannel = true;
      if (this.localAudioTrack) {
        this.localAudioTrack.close();
        this.localAudioTrack = null;
      }
      if (this.localVideoTrack) {
        this.localVideoTrack.close();
        this.localVideoTrack = null;
      }
      document.getElementById('participants').innerHTML = '';
      await this.agoraClient.leave();
    },

    async endTelehealthAttendance() {
      this.$swal({
        title: 'Encerrar chamada',
        text: 'Tem certeza que deseja encerrar esta chamada?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Encerrar chamada',
        cancelButtonText: 'Cancelar',
        focusConfirm: true
      }).then((res) => {
        if(res.value) {
          this.telehealthAttendance.end_datetime = 1;
          this.leaveChannel();
        }
      });
    }
  },

  beforeDestroy() {
    if(this.telehealthCheckInterval != null) {
      clearInterval(this.telehealthCheckInterval);
    }
    this.leaveChannel();
  }
}
</script>

<style lang="scss">
  .telehealth {
    display: flex;
    overflow: hidden;
    width: 100%;
    min-height: 100vh;

    > .content {
      flex: 1;
      height: 100vh;
      overflow: scroll;
      overflow-x: hidden;
      background: #F4F4F4;
    }

    .info {
      .page-header {
        background: #fff;

        h1 {
          font-size: 26px;
        }
        h4 {
          font-size: 20px;
        }
        p, a {
          font-family: 'sf_pro_displayregular';
          color: #90A6B3;
        }
      }

      .box-cj {
        background: #FFFFFF;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        margin-bottom: 30px;

        .header {
          padding: 15px 20px;
          border-bottom: 1px solid $athenGray2;

          .title {
            font-size: 16px;
            margin-bottom: 0;
          }
        }

        .content {
          padding: 15px 20px;
        }
      }


      .jp-card {
        min-width: 0;
      }
    }

    #attendance_content {
      height: 740px;
    }

    .professional-status-loading {
      font-size: 24px;
      margin-top: 10px;
    }

    .professional-status-text {
      font-size: 18px;
    }

    .agora-uikit-cj {
      width: 100%;
      height: 100%;
      display: flex;

      .agora-call {
        min-height: 0px;
        display: flex;
        flex: 1 1 0;
        flex-direction: column;

        #participants {
          width: 100%;
          height: 100%;
          display: grid;
        }
      }
    }

    .credits {
      font-family: 'sf_pro_displayregular';
      font-size: 14px;
      color: $cadetGray;

      a {
        font-family: 'sf_pro_displaysemibold';
        color: $cadetGray;
      }
    }

    .font-lighter {
      font-family: 'sf_pro_displaylight';
    }

    .font-2x {
      font-size: 1.5em;
    }

    .pointer {
      cursor: pointer;
    }

    .disabled {
      opacity: 0.5;
      cursor: unset;
    }

    .btn.btn-primary {
      background-color: $tangaroa;
      border-color: $tangaroa;
      color: #ffffff;
    }
  }

  @media (max-width: 767px) {
    .telehealth .info .page-header {
      h1 {
        font-size: 20px;
      }
      h4 {
        font-size: 16px;
      }
      p {
        font-size: 15px;
      }
    }
  }
  @media (max-height: 991px) {
    #attendance_content {
      height: calc(100vh - 180px)!important;
      min-height: 450px;
    }
  }
</style>
